(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ac-policy-navigation"]) return;
  try {
    
  if (!customElements.get('ac-policy-navigation')) {
    customElements.define('ac-policy-navigation', class extends HTMLElement {
      connectedCallback() {
        this.cleanup?.();
        this.controller = new AbortController();
        const { signal } = this.controller;
        const disclosure = this.querySelector('details');
        const summary = disclosure.querySelector('summary');
        const panel = this.querySelector('nav');
        const content = this.closest('.ac-policy-layout')?.querySelector('.ac-policy-content');
        const media = window.matchMedia('(min-width: 1024px)');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const motionAllowed = () => !reduced.matches && document.body.dataset.acMotion !== 'reduced';
        this.dataset.enhanced = '';
        this.restoreContent = () => {
          if (this.contentWasInert === undefined) return;
          if (content) content.inert = this.contentWasInert;
          this.contentWasInert = undefined;
        };
        const setOpen = (open, animate = true) => {
          this.animation?.cancel();
          this.animation = null;
          if (media.matches) open = true;
          this.expanded = open;
          if (open) {
            disclosure.open = true;
            if (!media.matches && content && this.contentWasInert === undefined) {
              this.contentWasInert = content.inert;
              content.inert = true;
            }
          } else {
            this.restoreContent();
          }
          if (!animate || media.matches || !motionAllowed()) {
            disclosure.open = open;
            return;
          }
          const animation = panel.animate(
            [{transform: `scaleX(${open ? 0 : 1})`}, {transform: `scaleX(${open ? 1 : 0})`}],
            {duration:400,easing:'ease',fill:'both'}
          );
          this.animation = animation;
          animation.finished.then(() => {
            if (this.animation !== animation) return;
            disclosure.open = open;
            animation.cancel();
            this.animation = null;
          }).catch(() => {});
        };
        const sync = () => {
          this.restoreContent();
          setOpen(media.matches, false);
          if (!media.matches && panel.contains(document.activeElement)) summary.focus();
        };
        sync();
        media.addEventListener('change', sync, { signal });
        const settleMotion = () => {
          if (!motionAllowed()) setOpen(this.expanded, false);
        };
        reduced.addEventListener('change', settleMotion, { signal });
        const observer = new MutationObserver(settleMotion);
        observer.observe(document.body, { attributes: true, attributeFilter: ['data-ac-motion'] });
        this.cleanup = () => {
          this.controller?.abort();
          observer.disconnect();
          this.animation?.cancel();
          this.animation = null;
          this.restoreContent?.();
          delete this.dataset.enhanced;
        };
        document.addEventListener('shopify:section:unload', event => {
          if (event.target === this || event.target.contains?.(this)) this.cleanup();
        }, { signal });
        summary.addEventListener('click', event => {
          if (media.matches) return;
          event.preventDefault();
          setOpen(!this.expanded);
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape' || media.matches || !disclosure.open) return;
          event.preventDefault();
          setOpen(false);
          summary.focus();
        }, { signal });
        document.addEventListener('focusin', event => {
          // WebKit touch taps can focus the outer main before activating the link.
          if (document.documentElement.dataset.acInputMode !== 'keyboard') return;
          if (!media.matches && disclosure.open && !this.contains(event.target)) setOpen(false, false);
        }, { signal });
        document.addEventListener('pointerdown', event => {
          if (!media.matches && disclosure.open && !this.contains(event.target)) setOpen(false, false);
        }, { signal });
      }
      disconnectedCallback() {
        this.cleanup?.();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
